import { CommonModule } from '@angular/common';
import { BienesCulturalesService } from './../bienes-culturales.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Tipologia } from 'app/models/tipologias.model';
import { BehaviorSubject, map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { BienesFilterParams } from './models/bienes-filter-params';
import { environment as env } from 'environments/environments';
import { MatSelectModule } from '@angular/material/select';
import { AllColecciones } from 'app/models/all-colecciones.model';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'filtro-listado-bienes',
    templateUrl: 'filtro-listado.component.html',
    imports:[
        CommonModule, FormsModule, MatFormFieldModule, MatAutocompleteModule, MatInputModule, MatSelectModule,
        MatButtonModule
    ]
})

export class FiltroListadoComponent implements OnInit {

    @ViewChild('municipioInput') municipioInput!: ElementRef<HTMLInputElement>;
    
    tipology_departamentos:number= env.TIPOLOGIA_ID_DEPARTAMENTOS
    tipology_seccion:number = env.TIPOLOGIA_PADRE_ID_SECCION
    tipology_bien_mueble:number = env.TIPOLOGIA_ID_BIEN_MUEBLE
    tipology_bien_inmueble:number = env.TIPOLOGIA_ID_BIEN_INMUEBLE
    todas:number= 0
    readonly:boolean= false

    filter$ = new BehaviorSubject<string>('');
    allDepartamentos: Tipologia[] = [];
    departamentos$: Observable<Tipologia[]>;

    filterMunicipios$ = new BehaviorSubject<string>('');
    allMunicipios: Tipologia[] = [];
    municipios$: Observable<Tipologia[]>;

    filterColeccion$ = new BehaviorSubject<string>('');
    allColeccion: AllColecciones[] = [];
    colecciones$: Observable<AllColecciones[]>;

    colecciones:AllColecciones[]
    secciones:Tipologia[]

    sel:number


    categorias:Tipologia[]
    BienesFilters: Partial<BienesFilterParams>
    esLIstadoGeneral:boolean= false

    private destroy$ = new Subject<void>();
        
    constructor(
        private bienesService:BienesCulturalesService,
    ) { }

    ngOnInit() { 
        this.BienesFilters = {inicio:0, max:10};

        this.readonly=this.bienesService.bienesCulturealesFilterParmasValue.seccion ? true: false

        this.bienesService.listBienesCulturales$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.getDepartamento();
                this.getSeccion();
                this.getColecciones();
            });

        
    }
    
    getDepartamento() {
        this.bienesService.getTipologias(this.tipology_departamentos).then((response: Tipologia[]) => {
            this.allDepartamentos = response;
    
            this.departamentos$ = this.filter$.pipe(
            startWith(''),
            map(query =>
                this.allDepartamentos.filter(d =>
                d.descripcion.toLowerCase().includes(query.toLowerCase())
                )
            )
            );
        });
    }

    displayFn(departamento: Tipologia): string {
        return departamento ? departamento.descripcion : '';
    }

    getMunicipios(event:Tipologia){ 
        if (this.BienesFilters.municipio) {
             this.municipioInput.nativeElement.value = '';
        }

        this.BienesFilters.departamento = event.tipologiaId;

        this.bienesService.getTipologias(event.tipologiaId)
        .then((response: Tipologia[]) => {
            this.allMunicipios = response;

            this.municipios$ = this.filterMunicipios$.pipe(
            startWith(''),
            map(query =>
                this.allMunicipios.filter(m =>
                m.descripcion.toLowerCase().includes(query.toLowerCase())
                )
            )
            );
        });
    }

    getColecciones(){
        this.bienesService.getAllColecciones()
        .then((response:AllColecciones[])=>{
            this.allColeccion = response;

            this.colecciones$ = this.filterColeccion$.pipe(
            startWith(''),
            map(query =>
                this.allColeccion.filter(c =>
                c.descripcion.toLowerCase().includes(query.toLowerCase())
                )
            )
            );
        })
    }

    getSeccion() {
        const sel = this.bienesService.bienesCulturealesFilterParmasValue.seccion;
        console.log(sel)
        this.BienesFilters.seccion = sel !== undefined && sel !== null ? Number(sel) : this.todas;

        this.bienesService.getTipologias(this.tipology_seccion)
            .then((response: Tipologia[]) => {
                this.secciones = response;

                const existe = this.secciones.find(s => s.tipologiaId === this.BienesFilters.seccion);
                this.BienesFilters.seccion = existe ? this.BienesFilters.seccion : this.todas;
                this.BienesFilters.tipoBien = this.todas;
        });
    }


    municipioSelected(event:Tipologia){
        this.BienesFilters.municipio = event.tipologiaId;
    }

    coleccionSelected(event:AllColecciones){
        this.BienesFilters.coleccion = event.coleccionId;
    }

    filtrar(){
        this.bienesService.getFichaRegistro(this.BienesFilters)
        this.bienesService.bienesCulturealesFilterParmas = this.BienesFilters
    }

    onDepartamentoInput(value: string): void {
        this.filter$.next(value);

        if (!value?.trim()) {
            delete this.BienesFilters.departamento
        }
    }

    onMunicipioInput(value: string): void {
        this.filterMunicipios$.next(value);

        if (!value?.trim()) {
            delete this.BienesFilters.municipio;
        }
    }

    onTipoBienInput(value: any): void {
        if (!value || (typeof value === 'string' && value.trim() === '')) {
            delete this.BienesFilters.tipoBien;
        }
    }

    onColeccionesInput(value: any): void {
        this.filterColeccion$.next(value);

        if (!value?.trim()) {
            delete this.BienesFilters.coleccion;
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }


}